export default "__VITE_ASSET__CYtqqcsR__"